// src/components/shared/LoadingSpinner.jsx
// Generischer, kleiner CSS-Spinner - kann überall verwendet werden, wo auf einen
// asynchronen Vorgang gewartet wird (nicht nur bei der Extraktion).
import React from 'react';

function LoadingSpinner({ label }) {
    return (
        <div className="loading-spinner">
            <div className="loading-spinner-circle" />
            {label && <span className="loading-spinner-label">{label}</span>}
        </div>
    );
}

export default LoadingSpinner;